import { SelectedShippingRateSchema } from "@redotech/redo-fulfillment-carrier-common/carriers-and-services";
import { PrinterOptionsSchema } from "@redotech/redo-fulfillment-group-common/printer";
import * as z from "zod";

export const BuyRequestSchema = z.object({
  fulfillmentGroupId: z.string(),
  lineItems: z.array(z.object({ id: z.string(), quantity: z.number() })),
  shipmentRate: SelectedShippingRateSchema,
});
export type BuyRequest = z.infer<typeof BuyRequestSchema>;

export const BuyResponseSchema = z.object({
  success: z.boolean(),
  errorMessage: z.string().nullish(),
});
export type BuyResponse = z.infer<typeof BuyResponseSchema>;

export const LabelPrintTargetSchema = z.object({
  printerId: z.number(),
  printerOptions: PrinterOptionsSchema.optional(),
  workstationId: z.string().optional(),
});
export type LabelPrintTarget = z.infer<typeof LabelPrintTargetSchema>;

export const buyLabels = {
  name: "buyLabels" as const,
  input: z.object({
    buyRequests: z.array(BuyRequestSchema),
    userId: z.string(),
    print: z.boolean(),
    templateId: z.string().nullish(),
    fulfillmentDate: z.date().nullish(),
    notifyMarketplace: z.boolean().nullish(),
    initiationTime: z.number().nullish(),
    labelPrintTarget: LabelPrintTargetSchema.nullish(),
  }),
  output: z.object({
    batchId: z.string(),
    batchNumber: z.string(),
    labelPrintQueued: z.boolean().optional(),
  }),
};
